import { connect } from 'react-redux';
import SelectFilter from '../../components/Forms/SelectFilter';
import LoadingContainer from '../../components/Structure/Layouts/LoadingContainer';
import TitleContainer from '../../components/Structure/Layouts/TitleContainer';
import ActionTopBar from '../../components/Structure/Table/ActionTopBar';
import { translations as translations_eng } from '../../texts/eng/newsletter-translations'
import SimpleTable from './components/SimpleTable';
import AddNewsletterModal from './modals/AddNewsletterModal';
import EditNewsletterModal from './modals/EditNewsletterModal';
import useNewsletterView from './useNewsletterView';


const NewsletterView = ({ language, history, is_auth }) => {

    const content = translations_eng
    const { system, view_data, actions } = useNewsletterView({ language, history, is_auth, content })


    return (
        <LoadingContainer
            loading={system.loading}
            error={system.error}
            onCloseError={actions.onCloseError}
        >
            <TitleContainer title={content.title}>
                <AddNewsletterModal
                    open={view_data.add_modal}
                    form={view_data.form}
                    onChange={actions.onChange}
                    onSubmit={actions.onAddNewsletter}
                    onClose={actions.onCloseAddModal}
                    content={content.modals.add_modal}
                />
                <EditNewsletterModal
                    open={view_data.edit_modal}
                    form={view_data.form}
                    onChange={actions.onChange}
                    onSubmit={actions.onUpdateNewsletter}
                    onClose={actions.onCloseEditModal}
                    content={content.modals.edit_modal}
                />
                <ActionTopBar
                    filter={content.filter}
                    filterValue={view_data.filterValue}
                    onChangeFilter={actions.onUpdateFilterValue}
                    search
                    searchData={view_data.form.search}
                    onSearch={actions.onSearchNewsletter}
                    add
                    onUpdateSearch={actions.onResetTableFilter}
                    onAdd={actions.onOpenAddModal}
                />
                <SimpleTable
                    onSelectedItem={actions.onSelectNewsletter}
                    data={view_data.newsletters}
                    tableFilter={view_data.tableFilter}
                    onUpdateTableFilter={actions.onUpdateTableFilter}
                    total={view_data.total}
                    loading={system.sending}
                    onRemoveItem={actions.onPreDeleteRegister}
                    noData={content.noData}
                    header={content.header}
                />
            </TitleContainer>
        </LoadingContainer>
    )
}

const mapStateToProps = (state) => {
    return {
        language: state.language,
        is_auth: state.is_auth
    }
}

export default connect(mapStateToProps)(NewsletterView) 